
import EDRadioGroup from '../../../../../../../../../BaseComponents/RadioGroup/EDRadioGroup';

import { Theme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

interface IProps {
  printMode: PrintMode;
  setPrintMode: (newPrintMode: PrintMode) => void;
  portraitDisabled?: boolean;
  landscapeDisabled?: boolean;
}

const useStyles = makeStyles()(
  (theme: Theme) =>
    ({
      radioGroupFormControl: {
        '&&': { marginTop: 0, marginBottom: 4 },
      },
    } as const)
);

export enum PrintMode {
  portrait = 'portrait',
  landscape = 'landscape',
}

/**
 * Val av utskriftsstil för export dialog
 */
const EkonomiskAnalysExportLayoutSettings: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { classes } = useStyles();
  return (
    <EDRadioGroup
      value={props.printMode}
      row
      onChange={(value: string) => props.setPrintMode(value as PrintMode)}
      label="Layout"
      radioDefs={[
        {
          label: 'Stående',
          value: PrintMode.portrait,
          disabled: props.portraitDisabled,
        },
        {
          label: 'Liggande',
          value: PrintMode.landscape,
          disabled: props.landscapeDisabled,
        },
      ]}
      classes={{
        formControl: classes.radioGroupFormControl,
      }}
    />
  );
};

export default EkonomiskAnalysExportLayoutSettings;
